import { TravelRegistryType } from '@/module/Travel/Request/model/TravelRequestTypes';

import { RoleType } from '@feature/security';

export const travelApproverRoles = [
  RoleType.DISCIPLINE_ADMIN,
  RoleType.DEPARTMENT_ADMIN,
  RoleType.FACULTY_ADMIN,
  RoleType.VICE_DEAN,
  RoleType.RESEARCH_VICE_RECTOR,
  RoleType.INTERNATIONAL_VICE_RECTOR,
  // The offices decide the pooled steps of their own chain.
  RoleType.RESEARCH_ADMINISTRATIVE_OFFICE,
  RoleType.INTERNATIONAL_ADMINISTRATIVE_OFFICE,
] as const satisfies readonly RoleType[];

export const travelAdminRoles = [RoleType.ADMIN, RoleType.UNIVERSITY_ADMIN] as const satisfies readonly RoleType[];

export const travelOfficeRoles = [
  RoleType.RESEARCH_ADMINISTRATIVE_OFFICE,
  RoleType.INTERNATIONAL_ADMINISTRATIVE_OFFICE,
] as const satisfies readonly RoleType[];

export function isTravelApproverRole(role: RoleType) {
  return (travelApproverRoles as readonly RoleType[]).includes(role);
}

export function isTravelAdminRole(role: RoleType) {
  return (travelAdminRoles as readonly RoleType[]).includes(role);
}

export function isTravelOfficeRole(role: RoleType) {
  return (travelOfficeRoles as readonly RoleType[]).includes(role);
}

// Each office works one chain only, so its lists and exports are those of that chain's registry.
export function getTravelOfficeRegistryType(role: RoleType): TravelRegistryType | null {
  if (role === RoleType.RESEARCH_ADMINISTRATIVE_OFFICE) {
    return 'RESEARCH';
  }
  return role === RoleType.INTERNATIONAL_ADMINISTRATIVE_OFFICE ? 'ERASMUS' : null;
}

// The reporting endpoints answer 403 to every other role.
export const travelReportingRoles = [
  ...travelAdminRoles,
  ...travelOfficeRoles,
  RoleType.FACULTY_ADMIN,
] as const satisfies readonly RoleType[];

export function isTravelReportingRole(role: RoleType) {
  return (travelReportingRoles as readonly RoleType[]).includes(role);
}

// The day-balance people endpoint answers 403 to every other role.
export const travelDayBalancePeopleRoles = [
  ...travelAdminRoles,
  ...travelOfficeRoles,
  RoleType.FACULTY_ADMIN,
  RoleType.DEPARTMENT_ADMIN,
  RoleType.DISCIPLINE_ADMIN,
] as const satisfies readonly RoleType[];

export function isTravelDayBalancePeopleRole(role: RoleType) {
  return (travelDayBalancePeopleRoles as readonly RoleType[]).includes(role);
}

export function travelHomeFor(role: RoleType | undefined) {
  if (role != null && isTravelApproverRole(role)) {
    return '/travel/approvals';
  }
  if (role != null && isTravelAdminRole(role)) {
    return '/travel/settings';
  }

  return '/travel/requests';
}

// ADMIN holds only the legal-holidays tab of the administration section.
export function administrationHomeFor(role: RoleType | undefined) {
  return role === RoleType.ADMIN ? '/administration/legal-holiday' : '/administration/discipline';
}
